function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.003.579L7.765 4.15l3.941.572-2.851 2.78.673 3.925-3.525-1.853-3.525 1.853.673-3.925L.3 4.722l3.941-.572z",
  fill: "none",
  stroke: "#000",
  strokeWidth: "inherit",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgInspiration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.006 12.006"
  }, props), _ref);
}

export default SvgInspiration;